import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Dimension, { ChainNode } from "../components/Dimension";
import PageHead from "../components/PageHead";

import { LT_TOOLS, toolDescription, toolTag } from "../data";

const PRINCIPLES = [
  "solutions.highlights.openEcosystem",
  "solutions.highlights.automation",
  "solutions.highlights.community",
];

const STEPS = ["discover", "design", "deploy"];

function Solutions() {
  const { t } = useTranslation();

  return (
    <div className="container">
      <Seo page="solutions" path="/solutions" />

      <PageHead
        title={t("solutions.heroTitle")}
        lede={t("solutions.heroDesc")}
      />

      <div className="band">
        <Dimension
          label={t("dimension.principles", { n: PRINCIPLES.length })}
        />
      </div>
      <h2 className="h-section">{t("solutions.principlesTitle")}</h2>
      <p className="section-lede">{t("solutions.principlesDesc")}</p>
      <div className="col3">
        {PRINCIPLES.map((key) => (
          <div key={key}>
            <h3>{t(key + ".title")}</h3>
            <p>{t(key + ".description")}</p>
          </div>
        ))}
      </div>

      <div className="band">
        <Dimension label={t("dimension.toolSheets", { n: LT_TOOLS.length })} />
      </div>
      <h2 className="h-section">{t("solutions.suiteTitle")}</h2>
      <p className="section-lede">{t("solutions.suiteDesc")}</p>
      <div className="tool-sheets">
        {LT_TOOLS.map((tool) => {
          const hasLive = tool.url && tool.url !== tool.github;
          return (
            <article key={tool.key} className="tool-sheet">
              <img
                className="shot"
                src={`${process.env.PUBLIC_URL}${tool.image}`}
                alt={tool.title}
                loading="lazy"
                decoding="async"
                style={{ objectPosition: tool.imagePosition || "center" }}
              />
              <h3>{tool.title}</h3>
              <p>{toolDescription(t, tool)}</p>
              <div className="foot">
                <span>{toolTag(t, tool)}</span>
                <span>
                  {tool.closed
                    ? t("solutions.closed")
                    : tool.stars != null
                      ? t("solutions.stars", { n: tool.stars })
                      : "–"}
                </span>
                <span className="spacer" />
                {tool.github && (
                  <a
                    href={tool.github}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("solutions.code")}
                  </a>
                )}
                {hasLive && (
                  <a href={tool.url} target="_blank" rel="noopener noreferrer">
                    {t("solutions.visitTool")}
                  </a>
                )}
              </div>
            </article>
          );
        })}
      </div>

      <div className="band">
        <Dimension label={t("dimension.steps", { n: STEPS.length })} />
      </div>
      <h2 className="h-section">{t("solutions.journeyTitle")}</h2>
      <ol className="steps band-bottom">
        {STEPS.map((key, i) => (
          <li key={key}>
            <ChainNode n={i + 1} last={i === STEPS.length - 1} />
            <h3>{t(`solutions.journey.steps.${key}.title`)}</h3>
            <p>{t(`solutions.journey.steps.${key}.description`)}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default Solutions;
